import type { ZoneProfile } from '../services/zoneService';

/** Silent default cap applied before a zone format test (Jon Armstrong / Roger Eversolo case). */
export const UNTESTED_ZONE_DEFAULT_SAMPLE_RATE = 44100;
export const UNTESTED_ZONE_DEFAULT_BIT_DEPTH = 16;

export const UNTESTED_ZONE_BADGE_TEXT =
  '16/44 — untested; run the format test in Devices to unlock this zone\'s full quality';

export const DEVICES_FORMAT_TEST_PATH = '/app/devices';

export function hasVerifiedZoneFormat(profile: ZoneProfile | null | undefined): boolean {
  if (!profile) return false;
  if (profile.verified_at) return true;
  const results = profile.test_results;
  if (!results || typeof results !== 'object') return false;
  return Object.values(results).some((r) => r?.status === 'verified');
}

/** True when the zone still carries the untested 16/44 default ceiling. */
export function isUntestedDefaultZoneCap(profile: ZoneProfile | null | undefined): boolean {
  if (!profile || hasVerifiedZoneFormat(profile)) return false;
  return (
    profile.max_sample_rate === UNTESTED_ZONE_DEFAULT_SAMPLE_RATE
    && profile.max_bit_depth === UNTESTED_ZONE_DEFAULT_BIT_DEPTH
  );
}

export type ZoneFormatBadgeKind = 'untested_default' | 'verified_limit' | 'normal';

export function classifyZoneFormatBadge(
  profile: ZoneProfile | null | undefined,
  effectiveRateKhz: number | null,
  effectiveDepth: number | null,
  cappedByZone: boolean,
): ZoneFormatBadgeKind {
  if (
    isUntestedDefaultZoneCap(profile)
    && effectiveDepth === 16
    && effectiveRateKhz === 44
  ) {
    return 'untested_default';
  }
  if (cappedByZone && profile && hasVerifiedZoneFormat(profile)) {
    return 'verified_limit';
  }
  if (cappedByZone) {
    return 'verified_limit';
  }
  return 'normal';
}
